/**
 * @author Andrés Camilo Ferreira Rodríguez
 * @Copyright (c) Infotrack. All rights reserved.
 */
import { useProveedor } from '@infotrack/presentacion-componentes/proveedorEstado';
import Texto from '@infotrack/presentacion-componentes/texto';
import { TipoFormulario } from '@infotrack/presentacion-transversales/interfacesComunes';
import { useInputState } from '@infotrack/presentacion-utilitarios/hooks';
import {
    manejadorDialogoGlobal,
    manejadorIndicadorCargaGlobal,
} from '@infotrack/presentacion-utilitarios/manejadoresComponentes';
import IColumnas from 'Infotrack@Modelos/smartStock/columnas/entidades/columnas';
import { IEstadoGlobal } from 'Infotrack@Reductores/interfacesReductores';
import React from 'react';
import { connect } from 'react-redux';
import ColumnasCM from '../controladorModelo/columnasCM';
import { IFormularioColumnasCVProps } from '../interfaces';
import { acciones, IEstadoColumnas } from '../reductorColumnas';
import FormularioColumnasVista from '../vista/formularioColumnasVista';
import { useSelector } from 'react-redux';
import notificacionGlobal from '@infotrack/presentacion-componentes/notificacionGlobal';

const estadoInicial: IColumnas = {
    EmpresaId: '',
    DescripcionColumna: '',
    Estado: 1,
    AgenciaId: '',
};
const columnasCM = new ColumnasCM();

const FormularioColumnasCV: React.FunctionComponent<IFormularioColumnasCVProps> = ({ IdEmpresa }) => {
    const idAgencia = useSelector((estado: IEstadoGlobal) => estado.estadoAutenticacion.agenciaActual!.IdAgencia);
    const [{ estadoFormulario, tipoFormulario, entidadColumnas }, dispatch] = useProveedor<IEstadoColumnas>();
    const { alCambiarValor, setValor, reiniciar, valor } = useInputState<IColumnas>(estadoInicial);

    React.useEffect(() => {
        if (entidadColumnas && tipoFormulario !== TipoFormulario.Creacion) {
            setValor(entidadColumnas);
        } else {
            reiniciar();
        }
    }, [entidadColumnas]);

    const cerrarFormulario = () => {
        dispatch({ type: acciones.CAMBIAR_ESTADO_FORMULARIO, payload: null });
    };
    const confirmarCreacionEdicionColumnas = () => {
        if (columnasCM.validarEntidad(valor)) {
            manejadorDialogoGlobal({
                accionCancelar: () => manejadorDialogoGlobal({ estado: false }),
                accionConfirmar: crearEditarColumnas,
                estado: true,
                mensaje: (
                    <Texto
                        id={
                            tipoFormulario === TipoFormulario.Creacion
                                ? 'alerta.confirmacionCreacion'
                                : 'alerta.confirmacionEdicion'
                        }
                    />
                ),
                mostrarCancelar: true,
                tipoDialogo: 'Advertencia',
                titulo: <Texto id="titulo.advertencia" />,
            });
        }
    };

    const crearEditarColumnas = () => {
        manejadorDialogoGlobal({ estado: false });
        manejadorIndicadorCargaGlobal(true);
        if (tipoFormulario === TipoFormulario.Creacion) {
            columnasCM
                .crearColumnas({
                    ...valor,
                    AgenciaId: idAgencia,
                    EmpresaId: IdEmpresa,
                    Estado: valor.Estado === true || valor.Estado === 1 ? 1 : 0,
                })
                .then(() => {
                    cerrarFormulario();
                    manejadorIndicadorCargaGlobal(false);
                    dispatch({ type: acciones.RECARGAR_TABLA });
                });
        } else {
            columnasCM
                .editarColumnas({
                    ...valor,
                    AgenciaId: idAgencia,
                    EmpresaId: IdEmpresa,
                    Estado: valor.Estado === true || valor.Estado === 1 ? 1 : 0,
                })
                .then(() => {
                    cerrarFormulario();
                    manejadorIndicadorCargaGlobal(false);
                    dispatch({ type: acciones.RECARGAR_TABLA });
                });
        }
    };

    return (
        <FormularioColumnasVista
            accionCrearEditar={confirmarCreacionEdicionColumnas}
            cambiarInfoFomulario={alCambiarValor}
            columnas={valor}
            cerrarFormulario={cerrarFormulario}
            estadoFormulario={estadoFormulario}
            tipoFormulario={tipoFormulario}
        />
    );
};

const estadoAPropiedades = ({
    estadoAutenticacion: { usuarioInformacion },
}: IEstadoGlobal): IFormularioColumnasCVProps => ({
    IdEmpresa: usuarioInformacion!.IdEmpresa,
});

export default connect<IFormularioColumnasCVProps, null, any, IEstadoGlobal>(
    estadoAPropiedades,
    null
)(FormularioColumnasCV);
